module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19UT4Ly/tc-custom/9781783830138.jpg?1703821040194",
      "alt": "This image is the cover for the book No Ordinary War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No Ordinary War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("U-604 was a standard Type VIIC of which over 600 were built, and at first glance her six war patrols might seem typical - but they were far from ordinary.Using the official war diary and the eyewitness testimony of survivors this book weaves a detailed but vivid tapestry of life and action during some of the fiercest convoy battles of the Atlantic war. Often counter-attacked, but seeming to bear a charmed life, U-604 had her successes, including inflicting the largest single loss of US mercantile personnel in one attack. However, the drama of her career pales alongside the epic story of her loss. After repeated bombing by American aircraft, Hltring, the boat's CO, organised an amazing rescue attempt by two other U-boats and finally scuttled U-604. This rescue itself went badly wrong, leading to the loss of one more U-boat and Hltring's suicide in controversial circumstances. Based on interviews with survivors and illustrated with previously unpublished photos, it is simply an extraordinary story.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christian Prag\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Seaforth Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0